import LaporanHargaKubikasiKayu from "./LaporanHargaKubikasiKayu"

export default LaporanHargaKubikasiKayu
